// ProjectsFilterBar.tsx — Sprint 12. Search + 3 selects + clear
// button. Stateless: emits whole-filter-bag updates back to the
// orchestrator so it can apply them in one useMemo.
import React from 'react';
import { Button, Card, Input, Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import type { ProjectSearchFilters } from './projectTypes';
import { PRIORITY_OPTIONS, STATUS_OPTIONS } from './projectTypes';

const { Option } = Select;

export interface ProjectsFilterBarProps {
  filters:        ProjectSearchFilters;
  availableYears: number[];
  onChange:       (next: ProjectSearchFilters) => void;
  onClear:        () => void;
}

export const ProjectsFilterBar: React.FC<ProjectsFilterBarProps> = ({
  filters, availableYears, onChange, onClear,
}) => (
  <Card className="mb-6">
    <div className="flex flex-wrap gap-4">
      <Input
        placeholder="Search projects..."
        prefix={<SearchOutlined />}
        style={{ width: 250 }}
        value={filters.searchTerm}
        onChange={(e) => onChange({ ...filters, searchTerm: e.target.value })}
        allowClear
      />

      <Select
        placeholder="Filter by year"
        style={{ width: 150 }}
        allowClear
        value={filters.year}
        onChange={(year) => onChange({ ...filters, year })}
      >
        {availableYears.map(y => <Option key={y} value={y}>{y}</Option>)}
      </Select>

      <Select
        placeholder="Filter by status"
        style={{ width: 150 }}
        allowClear
        value={filters.status}
        onChange={(status) => onChange({ ...filters, status })}
      >
        {STATUS_OPTIONS.map(s => <Option key={s.value} value={s.value}>{s.label}</Option>)}
      </Select>

      <Select
        placeholder="Filter by priority"
        style={{ width: 150 }}
        allowClear
        value={filters.priority}
        onChange={(priority) => onChange({ ...filters, priority })}
      >
        {PRIORITY_OPTIONS.map(p => <Option key={p.value} value={p.value}>{p.label}</Option>)}
      </Select>

      <Button onClick={onClear}>Clear Filters</Button>
    </div>
  </Card>
);
